/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_File_RequiredInputs */

const cs_import_file_required = /** @type {(inputs: Import_File_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte soubor pro pokračování.`)
};

const en_import_file_required = /** @type {(inputs: Import_File_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a file to continue.`)
};

/**
* | output |
* | --- |
* | "Choose a file to continue." |
*
* @param {Import_File_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_file_required = /** @type {((inputs?: Import_File_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_File_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_file_required(inputs)
	return cs_import_file_required(inputs)
});